import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProps } from 'react-router';
import {
  DropDownSelectorValues,
  ProjectStatus as ProjectStatusEnum,
  SubPage,
  Tab,
} from '@symfa-inc/providence-verizon-types';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { LeasingHttpService } from '@core/services/http';
import { useLeasingTabPrefetch } from '@core/utils/hooks';
import {
  canUserEditByProjectStatusAndRoles,
  getProjectBundleIDParamFromUrl,
} from '@core/utils/methods';
import { EditablePage } from '@shared/components';
import { LeasingActions } from '@store/actions';
import {
  DDVSelectors,
  LeasingSelectors,
  ProjectSelectors,
  UserSelectors,
} from '@store/selectors';
import { LeasingSummary } from './components';

export const LeasingSummaryTab: FC<RouterProps> = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isLoading = useSelector(LeasingSelectors.getTabLoadingState('summary'));
  const isDataLoaded = useSelector(
    LeasingSelectors.getTabLoadedState('summary'),
  );

  const projectType = useSelector(LeasingSelectors.getProjectType);
  const projectTypePermission = useSelector(
    UserSelectors.canEditProjectByProjectType(projectType),
  );
  const canEdit = useSelector(
    UserSelectors.canEdit('leasing', SubPage.LeasingBrowse, Tab.Summary),
  );
  const userRoles = useSelector(UserSelectors.getUserRoles);
  const projectStatusId = useSelector(ProjectSelectors.getProjectStatus);
  const projectStatus = useSelector(
    DDVSelectors.getCurrentDDVValueById<ProjectStatusEnum>(
      DropDownSelectorValues.ProjectStatus,
      projectStatusId,
    ),
  );

  useLeasingTabPrefetch('summary', projectBundleID);

  useEffect(() => {
    if (!isDataLoaded) {
      dispatch(
        LeasingActions.setTabLoading.done({
          tabName: 'summary',
          isLoading: true,
        }),
      );
      HttpService.getHttpRequests(LeasingHttpService).getLeasingSummaryData(
        projectBundleID,
      );
    }
  }, [isDataLoaded]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-leasing-summary loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <EditablePage
      editableComponent={LeasingSummary}
      canUserEdit={
        canEdit &&
        projectTypePermission &&
        canUserEditByProjectStatusAndRoles(projectStatus, userRoles)
      }
    />
  );
};
